// extracted by mini-css-extract-plugin
export default {"top9px":"styles_top9px__pnbTO","top41px":"styles_top41px__s3zjo"};